import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { 
  Archive, Camera, Filter, X, ArrowLeft,
  Grid, List, Search, Play
} from "lucide-react";
import { Input } from "../components/ui/input";

const archiveCategories = ["All", "Students", "Events", "Campus", "Team", "Achievements"];

const archiveItems = [
  {
    id: 1,
    title: "Houston Crew 2017",
    category: "Team",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/1A_Houston_Crew_IMG_8049-min.jpg",
    type: "photo",
  },
  {
    id: 2,
    title: "Houston Headquarters",
    category: "Campus",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/1A_Houston-headquarters-city-skyline-min-1024x576.jpg",
    type: "photo",
  },
  {
    id: 3,
    title: "Flight School Florida",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/10/Escola-de-pilotagem-Florida_PEDRO-min-1024x768.jpg",
    type: "photo",
  },
  {
    id: 4,
    title: "Student Achievement",
    category: "Achievements",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/10/Luzimery-Garcia-min-1024x910.png",
    type: "photo",
  },
  {
    id: 5,
    title: "Community Service",
    category: "Events",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/10/Orvani-Food-Bank-min-768x1024.jpg",
    type: "photo",
  },
  {
    id: 6,
    title: "Pilot Training Program",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/10/Escola-de-pilotagem-Florida-min-1024x835.jpg",
    type: "photo",
  },
  {
    id: 7,
    title: "Student Life",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/10/IMG_1640-min-768x1024.jpg",
    type: "photo",
  },
  {
    id: 8,
    title: "Campus Activities",
    category: "Campus",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_2496-min.jpg",
    type: "photo",
  },
  {
    id: 9,
    title: "Graduation Celebration",
    category: "Achievements",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_2441-min-576x1024.jpg",
    type: "photo",
  },
  {
    id: 10,
    title: "Student Portrait",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_2423-min-768x1024.jpg",
    type: "photo",
  },
  {
    id: 11,
    title: "Group Event",
    category: "Events",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_1089-min.jpg",
    type: "photo",
  },
  {
    id: 12,
    title: "Team Meeting",
    category: "Team",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_1087-min.jpg",
    type: "photo",
  },
  {
    id: 13,
    title: "Student Success",
    category: "Achievements",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_1086-min-625x1024.jpg",
    type: "photo",
  },
  {
    id: 14,
    title: "Campus Event",
    category: "Events",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_0404-min.jpg",
    type: "photo",
  },
  {
    id: 15,
    title: "Outdoor Activities",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_0283-min.jpg",
    type: "photo",
  },
  {
    id: 16,
    title: "ELS Language Program",
    category: "Campus",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/ELS-Vesua-min.jpg",
    type: "photo",
  },
  {
    id: 17,
    title: "Rafael Gomes",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/2017-05-19-PHOTO-00000045-002Rafael-Gomes-min-768x1024.jpg",
    type: "photo",
  },
  {
    id: 18,
    title: "Student Journey",
    category: "Students",
    year: "2017",
    image: "https://www.m2l-usa.com/wp-content/uploads/2017/11/2017-05-19-PHOTO-00000040-002Rafael-Gomes-min-1024x768.jpg",
    type: "photo",
  },
  {
    id: 19,
    title: "Nana Lisa",
    category: "Students",
    year: "2018",
    image: "https://www.m2l-usa.com/wp-content/uploads/2018/02/Nana-Lisa-5.jpg",
    type: "photo",
  },
  {
    id: 20,
    title: "Reading Session",
    category: "Campus",
    year: "2018",
    image: "https://www.m2l-usa.com/wp-content/uploads/2018/02/reading.jpg",
    type: "photo",
  },
];

const videoTestimonials = [
  {
    id: "v1",
    name: "Jaciana Cortez",
    vimeoUrl: "https://vimeo.com/243339970",
    thumbnail: "https://www.m2l-usa.com/wp-content/uploads/2017/11/img-2.jpg",
  },
  {
    id: "v2",
    name: "Waldemiro Junqueira",
    vimeoUrl: "https://vimeo.com/243340359",
    thumbnail: "https://www.m2l-usa.com/wp-content/uploads/2017/11/man-3.jpg",
  },
  {
    id: "v3",
    name: "Ludiolma Oliveira",
    vimeoUrl: "https://vimeo.com/243340040",
    thumbnail: "https://www.m2l-usa.com/wp-content/uploads/2017/11/IMG_6777-1.jpg",
  },
  {
    id: "v4",
    name: "Alvaro Neto",
    vimeoUrl: "https://vimeo.com/244921672",
    thumbnail: "https://www.m2l-usa.com/wp-content/uploads/2017/11/Screen-Shot-2017-11-29-at-10.00.56-AM.jpg",
  },
];

const HeritageArchivePage = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredItems = archiveItems.filter((item) => {
    const matchesCategory = selectedCategory === "All" || item.category === selectedCategory;
    const matchesSearch = item.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <main className="pt-20">
      {/* Hero */}
      <section className="py-16 bg-surface-solid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <Link
            to="/heritage"
            className="inline-flex items-center gap-2 text-secondary hover:underline mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Heritage
          </Link>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-3 mb-6">
              <Camera className="w-6 h-6 text-secondary" />
              <span className="text-secondary text-sm font-medium tracking-[0.2em] uppercase">
                Photo & Media Archive
              </span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6">
              Legacy Media Gallery
            </h1>
            <p className="text-xl text-white/60">
              Browse through years of memories, achievements, and moments that 
              define our organization's journey.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 bg-[#060B19] border-b border-white/10 sticky top-20 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Search */}
            <div className="relative w-full md:w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <Input
                placeholder="Search archive..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 bg-white/5 border-white/10 text-white"
              />
            </div>

            {/* Categories */}
            <div className="flex flex-wrap items-center gap-2">
              <Filter className="w-4 h-4 text-white/40" />
              {archiveCategories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                    selectedCategory === cat
                      ? "bg-secondary text-[#060B19]"
                      : "bg-white/5 text-white/70 hover:bg-white/10"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* View Toggle */}
            <div className="flex items-center gap-2">
              <button
                onClick={() => setViewMode("grid")}
                className={`p-2 rounded-lg ${viewMode === "grid" ? "bg-white/10" : "hover:bg-white/5"}`}
              >
                <Grid className="w-5 h-5 text-white/70" />
              </button>
              <button
                onClick={() => setViewMode("list")}
                className={`p-2 rounded-lg ${viewMode === "list" ? "bg-white/10" : "hover:bg-white/5"}`}
              >
                <List className="w-5 h-5 text-white/70" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-12 bg-[#060B19]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <h2 className="font-heading text-2xl font-bold text-white mb-8">
            Photo Archive ({filteredItems.length} items)
          </h2>

          <div className={`grid gap-4 ${
            viewMode === "grid" 
              ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-4" 
              : "grid-cols-1 md:grid-cols-2"
          }`}>
            {filteredItems.map((item, idx) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                onClick={() => setSelectedImage(item)}
                className="group cursor-pointer"
              >
                <div className="relative aspect-square rounded-xl overflow-hidden glass-card">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform">
                    <h4 className="text-white font-semibold text-sm">{item.title}</h4>
                    <p className="text-white/60 text-xs">{item.category} • {item.year}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Testimonials */}
      <section className="py-16 bg-surface-solid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <h2 className="font-heading text-2xl font-bold text-white mb-8">
            Video Testimonials Archive
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {videoTestimonials.map((video) => (
              <a
                key={video.id}
                href={video.vimeoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                <div className="relative aspect-video rounded-xl overflow-hidden glass-card">
                  <img
                    src={video.thumbnail}
                    alt={video.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-secondary/20 border border-secondary/40 flex items-center justify-center group-hover:bg-secondary/40 transition-all">
                      <Play className="w-6 h-6 text-secondary ml-1" />
                    </div>
                  </div>
                </div>
                <h4 className="text-white font-semibold mt-3">{video.name}</h4>
                <p className="text-white/50 text-sm">Student Testimonial</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-all"
            >
              <X className="w-6 h-6 text-white" />
            </button>
            <motion.img
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              src={selectedImage.image}
              alt={selectedImage.title}
              className="max-w-full max-h-[80vh] object-contain rounded-xl"
            />
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-center">
              <h3 className="text-white font-heading font-bold text-xl">{selectedImage.title}</h3>
              <p className="text-white/60">{selectedImage.category} • {selectedImage.year}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA */}
      <section className="py-16 bg-[#060B19] border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            Want to Add to Our Archive?
          </h2>
          <p className="text-white/60 mb-8">
            If you're an alumni with photos or stories to share, we'd love to hear from you.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-[#060B19] rounded-lg font-semibold hover:bg-primary-hover transition-all"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
};

export default HeritageArchivePage;
